/* eslint-disable -- легаси-заглушка, бэкенд /subscriber удалён */
// Заглушка: подписка на рассылку отключена, бэкенд /subscriber удалён. Запрос не отправляется.
export const subscribeEmail = () => {
  return Promise.resolve({ success: true, result: null });
};
